/*
 * サブシステム名：運用
 * 機能名：初回パスワード再設定
 */

<template>
  <v-form class="pa-10">
    <v-container fill-height>
      <v-card class="mx-auto" min-width="25vw" min-height="415px" style="border-radius: 10px;">
        <v-row no-gutters justify="center">
          <v-img src="@/assets/ddlogo.png" max-width="22vw" max-height="10vh" contain class="mt-3"></v-img>
        </v-row>
        <v-row no-gutters>
          <v-col class="mt-2 px-1">
            <dd-section-title>
              <v-icon large>mdi-lock-outline</v-icon><span class="view-title">新規パスワード設定</span>
            </dd-section-title>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="mt-2 px-1">
            <span class="ml-1 view-description" style="color:green;margin-left:20px;font-size: smaller;"><v-icon color="green" small>mdi-information-outline</v-icon>初回ログインのため、パスワードの変更をお願いします。</span>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center">
          <v-col :cols=11 class="px-2">
            <dd-password-box
              ref="password"
              label="   "
              v-model="rec.password"
              :required="true"
              :valueType="Ctrls.InputTypes.Alphanumeric"
              :append-icon="currentpassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="currentpassword ? 'text' : 'password'"
              @click:append="currentpassword = !currentpassword"
              dense
              />
          </v-col>
        </v-row>
        <p style="white-space:pre-wrap;"></p>
        <v-row no-gutters justify="center">
          <v-col :cols=11 class="px-2">
            <dd-password-box
              ref="passwordNew"
              label="再入力"
              v-model="rec.passwordNew"
              :required="true"
              :valueType="Ctrls.InputTypes.Alphanumeric"
              :append-icon="currentpasswordNew ? 'mdi-eye' : 'mdi-eye-off'"
              :type="currentpasswordNew ? 'text' : 'password'"
              @click:append="currentpasswordNew = !currentpasswordNew"
              dense
              />
          </v-col>
        </v-row>
        <p style="white-space:pre-wrap;"></p>
        <v-row no-gutters>
          <v-col :cols=12 class="px-4 mt-5">
            <dd-login-button
                class="mb-5 py-2"
                :block=true
                max-height="10vh"
                @click="onClick"  >
                パスワードを変更
            </dd-login-button>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-form>
</template>
<script>
// import DdDefaultButton from '@/components/DdDefaultButton'
import DdSectionTitle from '@/components/DdSectionTitle'
import viewMixins from '@/mixins/viewMixins'
import DdPasswordBox from '@/components/DdPasswordBox'
import DdLoginButton from '@/components/DdLoginButton'
import messages from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import effects from '@/rahmen/utils/effects'

import { mapGetters } from 'vuex'

export default {
  name: 'PasswordEdit',
  mixins: [
    viewMixins
  ],
  components: {
    DdSectionTitle,
    DdPasswordBox,
    DdLoginButton
  },
  data: () => ({
    id: 0,
    rec: {
      password: '',
      passwordNew: '',
      sysFlg: true
    },
    currentpassword: false,
    currentpasswordNew: false,
    startPage: 'ddboard'
  }),
  computed: {
    ...mapGetters({
      msyssystemconfig: 'DDMasters/msysSystemConfig',
      loginInfo: 'users/loginInfo'
    })
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
    this.$store.dispatch('DDMasters/loadMasters', { list: ['msysmessage', 'msyssystemconfig'], version: 1 })
  },
  mounted () {
  },
  methods: {
    onClick: function () {
      const self = this
      console.log('onClick', self.msyssystemconfig)
      self.$store.dispatch('system/clearMessage')
      const isvalid = self.validateAll(self.$refs)
      console.log('validated', isvalid, self.$refs)
      if (!self.registerValidate()) { return }
      self.setDefaultStartPage().then(() => {
        if (!isvalid) { return }
        effects.loadStart()
        console.log('post')
        self.HttpClient.post(`/api/v1/mstUsanaviKokyaku/RegisterOwnPasswordForLite?id=${self.id}`, self.rec)
          .then((data) => {
            console.log('login', data, data.isValid, data.isExistsPayload)

            if (!data.isValid || !data.isExistsPayload) {
              console.log('login error route', data.summaryMessage)
              self.setInvalidMessage(self.$refs, data.invalidList)
              modals.showToastMessage(data.summaryMessage.messageCd, null, 800, null, 'info')
              effects.loadComplete()
              return
            }
            const tmpLoginInfo = Object.assign({}, self.loginInfo)
            const userInfo = data.payload.item2
            console.log('loginInfo', userInfo)
            userInfo.faceImage = tmpLoginInfo.faceImage
            console.log('faceImage', userInfo.faceImage)
            self.$store.dispatch('users/tryLogin', userInfo).then(() => {
              var url = location.href
              url = url.substring(0, url.indexOf('#/'))
              url = url + '#/' + self.startPage
              window.location.href = url
            })
          }).catch(function (error) {
            const m = messages.getInfo('COME0001')
            self.$store.dispatch('system/setMessage', m)
            console.log('post error')
            console.log(error)
            effects.loadComplete()
          })
      })
    },
    registerValidate: function () {
      if (this.rec.password !== this.rec.passwordNew) {
        this.$refs.password[this.Ctrls.SET_INVALID_METHOD](messages.get('COME0012'))
        this.$refs.passwordNew[this.Ctrls.SET_INVALID_METHOD](messages.get('COME0012'))
        return false
      }
      return true
    },
    setDefaultStartPage: function () {
      return new Promise(resolve => {
        const ret = this.msyssystemconfig.filter(function (elem) {
          return elem.configName === 'default_start_page'
        })
        if (ret.length > 0 && ret[0].configValue1 !== '') {
          this.startPage = ret[0].configValue1
        } else {
          this.startPage = 'ddboard'
        }
        resolve()
      })
    }
  }
}
</script>
<style scoped>
.version-text {
  font-size: small;
  font-family: Verdana;
  font-weight: bold;
}
</style>
